import { useMemo } from 'react';

/**
 * Animated floating particles background (light theme).
 * count: number of particles (default 18)
 */
function Particles({ count = 18 }) {
  const items = useMemo(() => {
    return Array.from({ length: count }, (_, i) => ({
      id:    i,
      size:  Math.random() * 5 + 2,
      left:  Math.random() * 100,
      top:   Math.random() * 100,
      dur:   Math.random() * 12 + 8,
      delay: Math.random() * 8,
      color: i % 3 === 0 ? 'rgba(124,58,237,.18)'
           : i % 3 === 1 ? 'rgba(8,145,178,.15)'
           :                'rgba(219,39,119,.12)',
    }));
  }, [count]);

  return (
    <div className="particles" aria-hidden="true" role="presentation">
      {items.map(p => (
        <div
          key={p.id}
          className="particle"
          style={{
            width:  p.size,
            height: p.size,
            left:   `${p.left}%`,
            top:    `${p.top}%`,
            background: p.color,
            animationDuration:  `${p.dur}s`,
            animationDelay:     `${p.delay}s`,
            boxShadow: `0 0 ${p.size * 2}px ${p.color}`,
          }}
        />
      ))}
    </div>
  );
}

export default Particles;
